import React, { useEffect, useState } from 'react';
import { Mail } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

/** Ask for a recipient email when none is on file. */
export const EmailPromptDialog = ({ open, onOpenChange, title, description, onSubmit, submitLabel = 'Send' }) => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setEmail(''); }, [open]);
  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  const submit = async (e) => {
    e.preventDefault();
    if (!valid) return;
    setBusy(true);
    try { await onSubmit(email.trim()); onOpenChange(false); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="email-prompt-dialog">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Mail className="h-5 w-5 text-blue-600" />{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
          <div className="space-y-2 py-4">
            <Label htmlFor="prompt-email">Email address</Label>
            <Input id="prompt-email" type="email" autoFocus placeholder="name@example.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="email-prompt-input" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" disabled={!valid || busy} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="email-prompt-submit">{busy ? 'Sending…' : submitLabel}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
